import { render, staticRenderFns } from "./AddInstaModal.vue?vue&type=template&id=54f7403e&"
import script from "./AddInstaModal.vue?vue&type=script&lang=js&"
export * from "./AddInstaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QBtn,QCardSection,QInput,QToggle,QTooltip,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QBtn,QCardSection,QInput,QToggle,QTooltip,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
